import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Box } from 'reflexbox';
import { Input } from 'rebass';

import actions from 'frontend/state/actions';
import { selectors as simbotSelectors } from 'frontend/state/reducers/simbot';
import { selectors as formSelectors } from 'frontend/state/reducers/simbot/form';

import config from 'frontend/config';

const ReportName = ({ name, defaultName, onChange }) => (
  <Box lg={5}>
    <Input
      label="Report Title"
      name="reportTitle"
      autoComplete="off"
      placeholder={defaultName}
      value={name}
      onChange={e => onChange(e.target.value)}
      color={config.color}
      backgroundColor={config.colors.primary}
      maxLength={100}
    />
  </Box>
);
ReportName.propTypes = {
  name: PropTypes.string,
  defaultName: PropTypes.string,
  onChange: PropTypes.func,
};
ReportName.defaultProps = {
  name: '',
  defaultName: '',
  onChange: () => {},
};

const mapStateToProps = (state, props) => ({
  name: formSelectors.userReportName(state, props),
  defaultName: simbotSelectors.defaultReportName(state, props),
});

const mapDispatchToProps = {
  onChange: actions.inputReportName,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportName);
